import React from "react";
import { SettingsWrapper, DayNightWrapper } from "./Wrapper.jsx";
export function OpticalSmokeEditor(props) {
    return <select className="form-control" {...props}>
        {["Off", "Low", "Normal", "High"].map((l, i) => <option key={i} value={i}>{l}</option>)}
    </select>
}

export default SettingsWrapper(DayNightWrapper(OpticalSmokeEditor));

